import PanelControl from './PanelControl';

export default PanelControl;
